<template>
  <div>
    <!-- <Header /> -->
    <div
      v-if="userInfo && userInfo.user"
      class="sticky top-0 z-50 bg-white shadow-md"
    >
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="pt-2 pb-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-4">
        <div class="flex justify-end">
          <router-link
            :to="{ name: 'InstructorBlogsList' }"
            class="bg-blues text-white hover:bg-hover hover:text-white rounded-xl text-xs font-semibold px-3 py-1.5"
            >Back</router-link
          >
        </div>

        <div>
          <form
            ref="blogRef"
            class="rounded-3xl p-5 sm:px-5 sm:py-2 heightfix overflow-y-auto shadow-md border"
            @submit.prevent="createBlogs"
          >
            <div class="flex flex-col sm:flex-row items-center justify-between">
              <h1
                class="py-2 text-xl sm:text-xl font-bold text-textblues text-center sm:text-left"
              >
                Blog
              </h1>
            </div>

            <div class="flex flex-col gap-3">
              <div class="flex flex-col sm:flex-row items-center gap-4 w-full">
                <div class="flex flex-col gap-2 w-full sm:w-1/2">
                  <label for="title" class="text-sm">
                    Title <span class="text-red-400">*</span>
                  </label>
                  <input
                    id="title"
                    type="text"
                    required
                    maxlength="100"
                    oninput="document.getElementById('title-count').textContent = 100 - this.value.length"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <p id="title-hint" class="text-xs text-gray-400">
                    <span id="title-count">100</span> characters remaining
                  </p>
                </div>

                <div class="flex flex-col gap-2 w-full sm:w-1/2">
                  <label for="category" class="flex gap-2 items-center text-sm">
                    Category <span class="text-red-400">*</span>
                    <svg
                      @click="is_CategoryPopup = true"
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 h-5 cursor-pointer"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#4caf50"
                        d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                      ></path>
                      <path fill="#fff" d="M21,14h6v20h-6V14z"></path>
                      <path fill="#fff" d="M14,21h20v6H14V21z"></path>
                    </svg>
                  </label>
                  <select
                    id="category"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="flex flex-col gap-2 w-full">
                <label for="thumbnail" class="text-sm"
                  >Thumbnail <span class="text-red-400">*</span></label
                >
                <input
                  id="thumbnail"
                  type="file"
                  required
                  class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                />
              </div>

              <div class="flex flex-col gap-2 w-full">
                <label for="description" class="text-sm"
                  >Description <span class="text-red-400">*</span></label
                >
                <QuillEditor
                  style="height: 300px"
                  theme="snow"
                  toolbar="full"
                  :content="description"
                  contentType="html"
                />
              </div>

              <div class="flex items-center gap-2">
                <input type="checkbox" id="Published" class="w-4 h-4" />
                <label for="Published" class="text-sm">Published</label>
              </div>

              <div class="flex justify-end">
                <div class="flex gap-3 flex-wrap items-center">
                  <button
                    type="button"
                    @click="is_CancelPopup = true"
                    class="border border-gray-300 rounded-lg text-sm font-semibold px-5 py-1.5 bg-white text-gray-700 hover:bg-gray-100 cursor-pointer"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'bg-blues hover:bg-hover cursor-pointer text-white border-none '
                    "
                    class="border rounded-lg text-sm font-semibold px-5 py-1.5"
                  >
                    Save
                  </button>

                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
                <!-- Cancel Confirmation Popup -->
                <div
                  v-if="is_CancelPopup"
                  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                >
                  <div
                    class="bg-white rounded-2xl shadow-lg overflow-hidden relative"
                  >
                    <!-- Close Button -->
                    <div
                      @click="is_CancelPopup = false"
                      class="absolute right-3 top-3 cursor-pointer"
                    >
                      <div
                        class="bg-red-500 hover:bg-red-600 text-white rounded-xl w-9 h-9 flex items-center justify-center text-lg font-bold"
                      >
                        ✕
                      </div>
                    </div>

                    <!-- Message Area -->
                    <div class="px-20 pt-12 pb-8 text-center">
                      <p class="text-gray-800 text-lg font-semibold mb-2">
                        Are you sure you want to cancel ?
                      </p>
                      <p class="text-textblues text-xl font-bold">Blog Creation</p>
                    </div>

                    <!-- Action Buttons -->
                    <div
                      class="bg-gray-100 px-4 py-3 flex justify-between gap-4"
                    >
                      <button
                        @click="is_CancelPopup = false"
                        class="w-20 bg-white border border-gray-300 text-gray-800 font-semibold rounded-xl hover:bg-gray-50 py-3"
                      >
                        Cancel
                      </button>
                      <button
                        @click="confirmCancel"
                        class="w-20 bg-blues hover:bg-hover text-white font-semibold rounded-xl py-3"
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Category Add in Course  -->
    <div
      v-if="is_CategoryPopup"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div
        class="w-11/12 sm:w-2/3 lg:w-1/3 bg-white rounded-lg shadow-lg py-6 sm:py-10 px-6 sm:px-8 relative"
      >
        <!-- Close Button -->
        <div
          @click="is_CategoryPopup = false"
          class="absolute right-4 top-4 cursor-pointer flex items-center"
        >
          <span
            class="text-gray-700 hover:text-red-500 text-sm sm:text-base"
          ></span>
          <img
            class="h-8 w-8 sm:h-6 sm:w-6 ml-2"
            src="@/assets/closebutton.svg"
            alt="Close"
          />
        </div>

        <h4
          class="text-gray-700 text-center text-lg sm:text-xl font-semibold mt-6"
        >
          Add Category
        </h4>

        <form class="w-full mx-auto mt-6" @submit.prevent="categoryAdd">
          <div class="flex flex-col gap-4">
            <div>
              <label
                for="categorytitle"
                class="text-sm sm:text-base font-medium"
              >
                Title <span class="text-red-400">*</span>
              </label>
              <input
                id="categorytitle"
                type="text"
                required
                class="w-full p-3 border border-gray-300 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <!-- Submit Button -->
            <div class="flex justify-end gap-3 items-center">
              <button
                type="submit"
                :disabled="categorySubmitting == true"
                :class="
                  this.categorySubmitting == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-hover cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-6 py-2"
              >
                Add Category
              </button>
              <img
                v-if="categorySubmitting"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import InstructorHeader from "@/components/Instructor/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    InstructorHeader,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    QuillEditor,
    FlashMessage,
  },

  data() {
    return {
      is_CategoryPopup: false,
      is_CancelPopup: false,
      categories: null,
      messages: {
        text: "",
        type: "null",
      },
      disable_submit: false,
      categorySubmitting: false,
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    this.categoryget();
  },

  methods: {
    // add the new Category in Course
    categoryAdd(el) {
      this.categorySubmitting = true;
      let bodyVal = {
        name: el.target.elements.categorytitle.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/blog-category/post/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          console.log(response.data.message);
          if (response.data.status == 200) {
            this.messages = {
              text: "Category Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.categorySubmitting = false;
              this.is_CategoryPopup = false;
              this.categoryget();
            }, 3000);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 3000);
          }
        });
    },
    categoryget() {
      axios
        .get(
          `${process.env.VUE_APP_API}/blog-category/list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data.data) {
            this.categories = res.data.data.data;
          }
        });
    },
    confirmCancel() {
      this.is_CancelPopup = false;
      this.$refs.blogRef.reset();
      this.$router.push({ name: "InstructorBlogsList" });
    },
    async createBlogs(e) {
      this.disable_submit = true;
      let token = this.userInfo.token_key;

      this.description = document.querySelector(".ql-editor").innerHTML;
      console.log(this.description);

      let urls = `${process.env.VUE_APP_API}/blog-details/post/?Key=${token}`;
      let HeaderVal = new FormData();

      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        HeaderVal.append("thumbnail", thumbnailVal);
      }

      HeaderVal.append("title", e.target.elements.title.value);

      HeaderVal.append(
        "category_id",
        parseInt(e.target.elements.category.value),
      );

      // HeaderVal.append("description", this.description);
      HeaderVal.append("content", this.description);

      HeaderVal.append("published", e.target.elements.Published.checked);
      HeaderVal.append("bolger_id", this.userInfo.user.id);

      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);

          if (response.data.status == 200) {
            this.messages = {
              text: "Blog Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.blogRef.reset();
              this.$router.push({
                name: "InstructorBlogsList",
              });
              this.disable_submit = false;
            }, 1500);
          } else {
            this.disable_submit = false;
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
  },
};
</script>

<style></style>
